<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Create Subscription plan"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Subscription Plan' })"
        />
      </b-col>
      <b-col md="12">
        <ValidationObserver v-slot="{ invalid, validate }" ref="observer">
          <form>
            <v-card class="upper-card">
              <div class="m-2 p-3">
                <h4 style="color: #727cf5">General</h4>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="planName"
                        >Name
                        <i
                          id="Name"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="Name"
                            placement="topright"
                            triggers="hover"
                            >Name Of subscription</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Plan name"
                      >
                        <b-form-input
                          class=""
                          id="planName"
                          inputType="text"
                          v-model="inputObject.planName"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="scopeOptions"
                        >Scope
                        <i
                          id="Scope"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="Scope"
                            placement="topright"
                            triggers="hover"
                            >Select user type for which plan can be
                            applicable</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Scope"
                      >
                        <eb-select
                          id="scopeOptions"
                          type="text"
                          label="label"
                          v-model="inputObject.scope"
                          :options="scopeOptions"
                          placeholder="Select Scope type"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-row class="mt-4 ml-2">
                      <label for="status"
                        >Status:
                        <i
                          id="1"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="1"
                            placement="topright"
                            triggers="hover"
                            >active or not</b-tooltip
                          ></i
                        >
                      </label>
                      <c-switch
                        class="mx-1"
                        color="success"
                        v-model="isActive"
                        label="label"
                        id="status"
                        variant="pill"
                        data-on="yes"
                        data-off="no"
                      />
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="8">
                    <div class="form-group">
                      <label for="description"
                        >Description
                        <i
                          id="Description"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="Description"
                            placement="topright"
                            triggers="hover"
                            >Description of subscription</b-tooltip
                          ></i
                        >
                      </label>
                      <br />
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="description"
                      >
                        <textarea
                          class="form-control"
                          rows="4"
                          cols="50"
                          id="description"
                          inputType="text"
                          maxlength="1500"
                          v-model="inputObject.description"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="orgAccessLevel"
                        >org Access Level
                        <i
                          id="orgAccessLevel"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="orgAccessLevel"
                            placement="topright"
                            triggers="hover"
                            >if u want this plan for specific organization or
                            all</b-tooltip
                          ></i
                        >
                      </label>
                      <eb-select
                        type="text"
                        v-model="inputObject.orgAccessLevel"
                        :options="orgAccessOptions"
                        label="label"
                        id="orgAccessLevel"
                        placeholder="Select org Access Level"
                      ></eb-select>
                    </div>
                    <div
                      v-if="
                        inputObject.orgAccessLevel &&
                        inputObject.orgAccessLevel.value === 'LIMITED'
                      "
                    >
                      <div class="form-group">
                        <label for="orgAccessLevel">org Access List </label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="org Access List"
                        >
                          <multiselect
                            v-model="inputObject.orgAccessList"
                            tag-placeholder="Add this as new org Access"
                            placeholder="Select org Access List"
                            label="name"
                            track-by="keys"
                            :options="orgAccessListOptions"
                            :multiple="true"
                            :taggable="false"
                            :open-direction="'bottom'"
                          ></multiselect>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </v-card>
            <v-card class="second-card">
              <div class="m-2 p-3">
                <h4 style="color: #727cf5">Pricing</h4>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="paymentType"
                        >Payment Type
                        <i
                          id="paymentType"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="paymentType"
                            placement="topright"
                            triggers="hover"
                            >NMode of payment</b-tooltip
                          ></i
                        >
                      </label>
                      <eb-select
                        id="paymentType"
                        type="text"
                        label="label"
                        v-model="inputObject.paymentType"
                        :options="paymentType"
                        placeholder="Select payment type"
                      ></eb-select>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="taxCode"
                        >Tax Code
                        <i
                          id="taxCode"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="taxCode"
                            placement="topright"
                            triggers="hover"
                            >tax code applicable for this plan</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Tax code"
                      >
                        <eb-select
                          id="taxCode"
                          type="text"
                          label="label"
                          v-model="inputObject.taxCode"
                          :options="taxcodeoptions"
                          placeholder="Select tax code"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="chargeCode"
                        >Charge Code
                        <i
                          id="chargeCode"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="chargeCode"
                            placement="topright"
                            triggers="hover"
                            >charge reference</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Charge code"
                      >
                        <b-form-input
                          id="chargeCode"
                          inputType="text"
                          maxlength="100"
                          v-model="inputObject.chargeCode"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="currency"
                        >Currency
                        <i
                          id="currency"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="currency"
                            placement="topright"
                            triggers="hover"
                            >currency of price</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="currency"
                      >
                        <eb-select
                          id="eventType"
                          label="labelDisplay"
                          v-model="inputObject.currency"
                          :options="currencyList"
                          placeholder="Select Currency"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="price"
                        >Price
                        <i
                          id="price"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="price"
                            placement="topright"
                            triggers="hover"
                          >
                            Amount of subscription</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="price"
                      >
                        <b-form-input
                          id="price"
                          inputType="Number"
                          maxlength="100"
                          v-model="inputObject.price"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <!-- <b-col
                    v-if="inputObject.cadencetype.value === 'EVENT'"
                    md="4"
                  >
                    <label for="eventType">Event </label>
                    <eb-select
                      id="eventType"
                      style="background-color: #fff;width:75%;"
                      type="text"
                      label="label"
                      v-model="inputObject.eventType"
                      :options="eventType"
                      placeholder="Select Event type"
                    ></eb-select>
                  </b-col> -->
                  <b-col md="4">
                    <div class="form-group">
                      <label for="uom"
                        >Unit Of Measurement
                        <i
                          id="uom"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="uom"
                            placement="topright"
                            triggers="hover"
                            >Type of Measurement for specific plan</b-tooltip
                          ></i
                        >
                      </label>
                      <eb-select
                        id="uom"
                        type="text"
                        label="label"
                        v-model="inputObject.uom"
                        :options="unitOfMeasurementtype"
                        placeholder="Select payment type"
                      ></eb-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="baseQuantity">
                        Base Quantity
                        <i
                          id="baseQuantity"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="baseQuantity"
                            placement="topright"
                            triggers="hover"
                            >Quantity of Subscription user</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Base quantity"
                      >
                        <b-form-input
                          id="baseQuantity"
                          inputType="Number"
                          maxlength="100"
                          v-model="inputObject.baseQuantity"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="cadence"
                        >Cadence Type
                        <i
                          id="cadence"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="cadence"
                            placement="topright"
                            triggers="hover"
                            >Kind of subscription plan</b-tooltip
                          ></i
                        >
                      </label>
                      <eb-select
                        id="cadence"
                        type="text"
                        label="label"
                        v-model="inputObject.cadencetype"
                        :options="cadencetype"
                        placeholder="Select Cadence type"
                      ></eb-select>
                    </div>
                  </b-col>
                  <b-col
                    v-if="inputObject.cadencetype.value === 'EVENT'"
                    md="4"
                  >
                    <div class="form-group">
                      <label for="eventType"
                        >Event
                        <i
                          id="event"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="event"
                            placement="topright"
                            triggers="hover"
                            >Applicable for Event</b-tooltip
                          ></i
                        >
                      </label>
                      <eb-select
                        id="eventType"
                        type="text"
                        label="label"
                        v-model="inputObject.eventType"
                        :options="eventType"
                        placeholder="Select Event type"
                      ></eb-select>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-row class="mt-4 ml-2">
                      <label for="autoRenewal"
                        >Auto Renewal :
                        <i
                          id="autoRenewal"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="autoRenewal"
                            placement="topright"
                            triggers="hover"
                          >
                            If this subscription auto renewable or
                            not</b-tooltip
                          ></i
                        >
                      </label>
                      <c-switch
                        class="mx-1"
                        color="success"
                        v-model="autoRenewal"
                        label="label"
                        id="autoRenewal"
                        variant="pill"
                        data-on="yes"
                        data-off="no"
                      />
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </v-card>
            <v-card>
              <div class="m-2 p-3">
                <h4 style="color: #727cf5">Provisioning</h4>
                <b-row>
                  <!-- <b-col md="4">
                    <label for="planAccess">Plan Access </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="planAccess"
                    > -->
                  <!-- <eb-select
                        style="background-color: #fff;width:75%;"
                        id="scopeOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.planAccess"
                        :options="accessrulesList"
                        placeholder="Select Scope type"
                      ></eb-select> -->
                  <!-- <b-input
                      style="width: 75%;"
                      id="rewardValue"
                      type="text"
                      v-model="inputObject.planAccess"
                    ></b-input> -->
                  <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col> -->
                  <b-col md="4">
                    <div class="form-group">
                      <label for="plantype">Plan Type </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Plan type"
                      >
                        <eb-select
                          id="plantype"
                          type="text"
                          label="label"
                          v-model="inputObject.planType"
                          :options="planType"
                          placeholder="Select plan type"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="validity"
                        >Validity
                        <i
                          id="validity"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="validity"
                            placement="topright"
                            triggers="hover"
                            >Based on Cadence Type eg: 1, means one month if
                            cadence is monthly if cadence is event, the validity
                            value should be considers as days</b-tooltip
                          ></i
                        >
                      </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="validity"
                      >
                        <b-form-input
                          id="validity"
                          type="number"
                          maxlength="100"
                          v-model="inputObject.validity"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col v-if="inputObject.planType.value == 'LIMIT'" md="4">
                    <div class="form-group">
                      <label for="planlimit">Plan Limit </label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Plan limit"
                      >
                        <b-form-input
                          id="planlimit"
                          type="number"
                          style="width: 75%"
                          maxlength="100"
                          v-model="inputObject.planlimit"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="planFeatures"
                        >Features
                        <i
                          id="Features"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="Features"
                            placement="topright"
                            triggers="hover"
                            >List of features will be giving here</b-tooltip
                          ></i
                        >
                      </label>
                      <b-row
                        v-for="(e, idx) in inputObject.planFeatures"
                        :key="idx"
                      >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Plan features"
                        >
                          <b-form-input
                            id="planFeatures"
                            class="ml-2"
                            style="width: 226px"
                            inputType="text"
                            v-model="e.planFeatures"
                          />
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <b-button
                         :variant="e.isRemovable ? 'danger' : 'success'"
                          class="fixed-width-button "
                          size="md"
                           @click="onClickEamilButton(e, idx)"
                        >
                          <i
                            v-if="!e.isRemovable"
                            class="fa fa-plus-circle "
                          ></i>
                          <i
                            class="fa fa-minus-circle "
                            v-if="e.isRemovable"
                          ></i>
                          {{ e.text }}
                        </b-button>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-row class="mt-4 ml-2">
                      <!-- <label for="isActive">isActive :</label> -->
                      <!-- <c-switch
                        class="mx-1"
                        color="success"
                        v-model="isActive"
                        label="label"
                        id="isActive"
                        variant="pill"
                        data-on="yes"
                        data-off="no"
                      /> -->
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </v-card>
            <div class="text-center mt-3 mb-3">
              <button
                type="button"
                class="btn btn-primary"
                v-on:click="validate"
                :disabled="invalid"
                 text="Save"
                @click.prevent="handleSubmit"
              >
                Save
              </button>
            </div>
          </form>
        </ValidationObserver>
        <!-- </v-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subscriptionplanDetails from "@/components/MasterSetup/subscriptionplan/SubscriptionplanDetails";
import { mapGetters } from "vuex";
import { getAllISOCodes } from "@/shared/currency";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "createSubscription",
  components: {
    ebButton,
    cSwitch,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    subscriptionplanDetails,
    ComponentHeader,
  },
  data: () => {
    return {
      currencyList: {},
      show: true,
      currentProvider: "",
      autoRenewal: true,
      isActive: true,
      status: true,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        cadencetype: "",
        scope: "",
        orgAccessLevel: "",
        orgAccessList: "",
        planName: "",
        taxCode: "",
        chargeCode: "",
        description: "",
        planType: "",
        planlimit: "",
        validity: "",
        planAccess: "",
        paymentType: "",
        cadencetype: "",
        eventType: "",
        price: "",
        currency: "",
        baseQuantity: "",
        uom: "",
        planFeatures: [
          {
            planFeatures: "",
            isRemovable: false,
            text: "Add",
          },
        ],
      },
      paymentType: [
        {
          label: "Prepaid",
          value: "PRE-PAID",
        },
        {
          label: "Postpaid",
          value: "POST-PAID",
        },
      ],
      orgAccessOptions: [
        {
          label: "GLOBAL",
          value: "GLOBAL",
        },
        {
          label: "LIMITED",
          value: "LIMITED",
        },
      ],

      cadencetype: [
        {
          label: "Monthly",
          value: "MONTHLY",
        },
        {
          label: "Quarterly",
          value: "QUARTERLY",
        },
        {
          label: "One time",
          value: "ONE-TIME",
        },
        {
          label: "Event",
          value: "EVENT",
        },
      ],
      scopeOptions: [
        {
          label: "Partner",
          value: "PARTNER",
        },
        {
          label: "Customer",
          value: "CUSTOMER",
        },
      ],
      planType: [
        {
          label: "Duration",
          value: "DURATION",
        },
        {
          label: "Limit",
          value: "LIMIT",
        },
      ],
      eventType: [
        {
          label: "Order-Fulfilled",
          value: "ORDER_FULFILLED",
        },
      ],
      unitOfMeasurementtype: [
        {
          label: "Occurrence",
          value: "OCCURRENCE",
        },
        {
          label: "Minute",
          value: "MINUTE",
        },
        {
          label: "Second",
          value: "SECOND",
        },
        {
          label: "GB",
          value: "GB",
        },
        {
          label: "MB",
          value: "MB",
        },
        {
          label: "Amount",
          value: "AMOUNT",
        },
      ],
    };
  },
  mounted() {
    this.getCatalogName();
    this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (this.inputObject.orgAccessLevel.value === "LIMITED") {
            let arrayObj = {
              keys: obj._id,
              name: obj.authentication.userName,
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
    taxcodeoptions() {
      let data = this.$store.getters["taxcode/GetTaxcodeList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          label: d.taxCode,
          value: d._id,
        }));
      }
      return [];
    },
    accessrulesList() {
      let data = this.$store.getters["accessrule/accessRuleList"];
      this.loading = false;
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            label: d.name.toUpperCase(),
            value: d._id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.inputObject.planFeatures.push({
          planFeatures: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.inputObject.planFeatures.splice(idx, 1);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let x = [];
      if (this.inputObject.orgAccessLevel.value == "LIMITED") {
        this.inputObject.orgAccessList.forEach((obj) => {
          x.push(obj.keys);
        });
      }
      let data = {};

      if (
        this.inputObject.cadencetype.value &&
        this.inputObject.cadencetype.value == "EVENT"
      ) {
        this.inputObject.price = this.inputObject.price / 100;
      } else {
        this.inputObject.price = this.inputObject.price;
      }
      data = {
        scope: this.inputObject.scope.value,
        planName: this.inputObject.planName,
        planDescription: this.inputObject.description,
        planFeatures: this.inputObject.planFeatures.map((t) => t.planFeatures),
        provisioning: {
          //   planLimit: this.inputObject.planlimit,
          planType: this.inputObject.planType.value,
          validity: this.inputObject.validity,
        },
        // planAccess: this.inputObject.planAccess.value,
        paymentType: this.inputObject.paymentType.value,
        autoRenewal: this.autoRenewal,
        taxCode: this.inputObject.taxCode.value,
        chargeCode: this.inputObject.chargeCode,
        pricing: {
          cadence: this.inputObject.cadencetype.value,
          eventType: this.inputObject.eventType.value,
          price: this.inputObject.price,
          currency: this.inputObject.currency.currency,
          baseQuantity: this.inputObject.baseQuantity,
          uom: this.inputObject.uom.value,
        },
        orgAccess: {
          orgAccessLevel: this.inputObject.orgAccessLevel.value,
          orgAccessList: x,
        },
        isActive: this.isActive,
      };

      if (this.inputObject.planType.value == "LIMIT") {
        data.provisioning.planLimit = this.inputObject.planlimit;
      } else {
      }
      try {
        await this.$store.dispatch(
          "subscriptionplan/createSubscriptionplan",
          data
        );
        await this.$store.dispatch(
          "subscriptionplan/subscriptionplanList",
          this.$store.getters["auth/getUserID"]
        );
        this.$swal({
          title: "Success",
          text: "Subscriptionplan Created Successfully",
          type: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
        }).then(() => {
          this.$router.push({ name: "Subscription Plan" });
        });
      } catch (error) {
        this.$swal({
          title: "Opps!!!!",
          text: "Can Not Create Subscriptionplan!!",
          type: "error",
        });
      }
      // this.$store.dispatch(
      //   "subscriptionplan/subscriptionList",
        this.$store.getters["auth/getUserID"]
      // );
    },
  },
  created() {
    this.currencyList = getAllISOCodes();
  },
  async mounted() {
    try {
      await this.$store.dispatch("partner/officeList");
      await this.$store.dispatch("role/fetchRoles");
      await this.$store.dispatch(
        "taxcode/fetchTaxcodeListforTenant",
        this.$store.getters["auth/getUserID"]
      );

      await this.$store.dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      );
    } catch (error) {
      this.$toasted.error(error.message);
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.upper-card {
  overflow: visible;
  z-index: 20;
}
.second-card {
  overflow: visible;
  z-index: 10;
}
 .fixed-width-button {
  min-width: 80px;
  height: 37px;
 }
 .btn-primary{
  width: 100px;
  font-size: 13px;
 }
</style>
